import { effect, inject, Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/environment';
import CookieManager from '../../utils/cookie-manager';
import { CtrlModalsService } from '@co-3/ctrl-ui/modals';
import { CookieSettingsComponent } from './cookie-settings.component';

declare let gtag: (...args: unknown[]) => void;
declare let fbq: (...args: unknown[]) => void;

@Injectable({
    providedIn: 'root',
})
export class CookieSettingsService {
    public cookieManager = new CookieManager('cookiesAllowed');
    public showCookieSettingsDialog = signal<boolean>(true);
    private modalService = inject(CtrlModalsService);

    public constructor() {
        this.showCookieSettingsDialog.set(!this.cookieManager.getValue('cookiesAllowed'));
        this.initScripts();
        effect(() => {
            const showCookies = this.showCookieSettingsDialog();
            if (showCookies) {
                this.modalService.openBlocking(CookieSettingsComponent);
            }
        });
    }

    public initScripts(): void {
        this.initGA();
        this.initFbq();
    }

    private initGA(): void {
        if (this.cookieManager.getAllowance('google') && typeof window['gtag'] === 'undefined') {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = environment.gtagUrl;
            script.onload = (): void => {
                window['dataLayer'] = window['dataLayer'] || [];
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                window['gtag'] = function (...args: unknown[]): void {
                    // eslint-disable-next-line prefer-rest-params
                    window['dataLayer'].push(arguments);
                };
                gtag('js', new Date());
                gtag('config', environment.googleAnalyticsId, { send_page_view: false, anonymize_ip: true });
                gtag('config', environment.googleConversionId);
                // track the current page
                gtag('event', 'page_view');
            };
            document.getElementsByTagName('body')[0].appendChild(script);
        }
    }

    private initFbq(): void {
        // prettier-ignore
        if (this.cookieManager.getAllowance('meta') && typeof window['fbq'] === 'undefined') {
            /* eslint-disable */
            // @ts-expect-error minified fbq install code taken from meta
            !function(f,b,e,v,n,t,s)
            // @ts-ignore
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            // @ts-ignore
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            /* eslint-enable */
            fbq('init', environment.metaPixelId);
            fbq('track', 'PageView');
        }
    }
}
